import React from 'react';
import './LandingPage.css';
import backgroundimage from '../resources/traktor_horizontal.jpg';
import DescriptionCards from './DescriptionCards';
import IconDescription from './IconDescription';

interface ILandingPageProps {
}

interface ILandingPageState {
}

export default class LandingPage extends React.Component<ILandingPageProps, ILandingPageState>{

    render() {
        return (
            <div id="landing-page">

                <header>
                    <img src={backgroundimage} className="background-image" alt="Some machines." />
                    <section className='centered'>
                        <h2>CORD VON OHLEN</h2>
                        <h2>LANDTECHNIK</h2>
                        <p>Gebrauchtmaschinen- und Zubehörhandel, Restaurationen und Reparaturen</p>
                    </section>
                </header>
                
                <IconDescription />

            </div>
        )
    }

}
